module.exports = __webpack_public_path__ + "media/images/emblems/Herbetswil-blason-99e13c2a51d12e054459db901add6b7c.png";